export const GET_ARRAY_OF_DASHBOARD = "GET_ARRAY_OF_DASHBOARD";
export const GET_JSON_OF_DASHBOARD = "GET_JSON_OF_DASHBOARD";
